import { defineStore } from "pinia";
import { computed, ref } from "vue";

const KEY = "flap_lang";

export const useLangStore = defineStore("lang", () => {
  const locale = ref(
    (() => {
      try {
        const v = localStorage.getItem(KEY);
        return v === "en" ? "en" : "zh";
      } catch {
        return "zh";
      }
    })()
  );

  const isEn = computed(() => locale.value === "en");

  function t(zh, en) {
    return isEn.value ? en || zh : zh;
  }

  function syncDocumentTitle() {
    const router = window.__FLAP_ROUTER__;
    const route = router?.currentRoute?.value;
    if (route?.meta?.titleZh) {
      document.title = t(route.meta.titleZh, route.meta.titleEn || route.meta.titleZh);
    }
  }

  function applyLocale() {
    document.documentElement.lang = locale.value === "en" ? "en" : "zh-CN";
    document.documentElement.setAttribute("data-lang", locale.value);
    syncDocumentTitle();
  }

  function toggle() {
    locale.value = locale.value === "en" ? "zh" : "en";
    try {
      localStorage.setItem(KEY, locale.value);
    } catch {
      /* ignore */
    }
    applyLocale();
  }

  applyLocale();

  return { locale, isEn, toggle, t, applyLocale, syncDocumentTitle };
});
